import { Suspense, useEffect } from 'react'
import { lazyRouteComponent, useNavigate } from '@tanstack/react-router'

import { PageSkeleton } from '@/components/ui/PageSkeleton'
import { useAuthStore } from '@/stores/useAuthStore'

const LandingPage = lazyRouteComponent(
  () => import('@/domains/landing/pages/LandingPage'),
  'LandingPage',
)

/**
 * `/` is the public landing. The auth store does not persist the token, so a signed-in
 * visitor is only recognised once the silent refresh resolves — render the landing right
 * away and redirect after, rather than blocking the page on an auth check.
 */
export default function IndexRoot() {
  const navigate = useNavigate()
  const token = useAuthStore((s) => s.token)
  const hasHydrated = useAuthStore((s) => s.hasHydrated)

  useEffect(() => {
    if (hasHydrated && token) navigate({ to: '/dashboard', replace: true })
  }, [hasHydrated, token, navigate])

  return (
    <Suspense fallback={<PageSkeleton />}>
      <LandingPage />
    </Suspense>
  )
}
